import React, { Fragment } from 'react'
import { Pill } from '@myxplor/ui'
import RecordDisplayList from '../../../ui/record-display-list'

const GovRegistrationBadges = ({ record }) => (
  <Fragment>
    <h4>{record.gov_record.OperatorName}</h4>
    <ul>
      <li>
        <Pill>{record.gov_record.ServiceType}</Pill>
      </li>
      <li>
        <Pill>{record.gov_record.CCBApprovalStatus}</Pill>
      </li>
    </ul>
  </Fragment>
)

const serviceAddress = ({ ServiceStreet, ServiceSuburb, ServiceState, ServicePostcode }) =>
  [ServiceStreet, ServiceSuburb, ServiceState, ServicePostcode].filter(val => val).join('\u000A')

const GovRegistrationList = ({ records = [], topContent }) => (
  <RecordDisplayList
    recordBadgesComponent={GovRegistrationBadges}
    records={records}
    name="CCMS Registration"
    topContent={topContent}
    recordBase="gov_record"
    showRaw
    level1={[
      {
        label: 'Address',
        fn: serviceAddress,
      },
      {
        key: 'ServicePhoneNumber',
        label: 'Phone number',
      },
      {
        key: 'ServiceEmail',
        label: 'Email',
      },
      {
        key: 'ServiceABN',
        label: 'ABN',
      },
    ]}
    level2={[
      {
        key: 'OperatorStreet',
        label: 'Operator street',
      },
      {
        key: 'OperatorSuburb',
        label: 'Operator suburb',
      },
      {
        key: 'OperatorState',
        label: 'Operator state',
      },
      {
        key: 'OperatorPostcode',
        label: 'Operator postcode',
      },
      {
        key: 'ListOfOperationalProfiles.OperationalProfile.OperationalStatus',
        label: 'Operational status',
      },
      {
        key: 'ListOfOperationalProfiles.OperationalProfile.ListOfHours.Hours.Open',
        label: 'Open at',
      },
      {
        key: 'ListOfOperationalProfiles.OperationalProfile.ListOfHours.Hours.Close',
        label: 'Closed at',
      },
      {
        key: 'ListOfOperationalProfiles.OperationalProfile.ListOfHours.Hours.Day',
        label: 'Days open',
      },
      {
        key: 'ListOfOperationalProfiles.OperationalProfile.HoursPerWeek',
        label: 'Hours per week',
      },
      {
        key: 'CCBStartDate',
        label: 'CCB start date',
      },
      {
        key: 'CCBEndDate',
        label: 'CCB end date',
      },
      {
        key: 'CCBApprovalStatus',
        label: 'CCB approval status',
      },
      {
        key: 'CCBApprovalId',
        label: 'CCB approval ID',
      },
    ]}
  />
)

export default GovRegistrationList



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccms-registrations/list.jsx